<template>
  <div class="bto-sb-element">
    <livestream-component
      v-if="!disableVideoStream"
      :streamId="streamId"
      :key="streamId"
      :isOnlyVideo="true"
      :providerId="providerId" />
    <horse-racing-widget />
    <schedule-races-widget-hr />
  </div>
</template>

<script>
  import LivestreamComponent from "../../common/match/livestream-component.vue";
  export default {
    name: "LiveHorseRacingComponent",
    components: {
      LivestreamComponent,
    },
    data() {
      return {
        streamId: this.$route.params.matchId.replace("eeid:", ""),
        providerId: +this.$route.params.providerId,
        disableVideoStream: APP_SETTINGS.settings.disableVideoStream
      };
    },
    created() {
      this.$store.commit("hideAfterRouteWidgets");
    },
    watch: {
      $route: function (to) {
        this.streamId = to.params.matchId.replace("eeid:", "");
        this.providerId = +to.params.providerId;
      },
    },
  };
</script>